export default __webpack_public_path__ + "static/media/cart-empty.27846abe.gif";